import { createContext, FC, ReactNode, useContext, useState } from 'react';

interface iRouteDataContext {
  getData: (key: string) => unknown;
  setData: (key: string, value: unknown) => void;
  flush: () => void;
}

const RouteDataContext = createContext<iRouteDataContext | null>(null);

const RouteDataProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [data, set] = useState<Record<string, unknown>>({});

  const getData = (key: string) => data[key];

  const setData = (key: string, value: unknown) =>
    set((clean) => ({
      ...clean,
      [key]: value
    }));

  const flush = () => set({});

  const values = {
    getData,
    setData,
    flush
  };

  return (
    <RouteDataContext.Provider value={values}>
      {children}
    </RouteDataContext.Provider>
  );
};

export const useRouteData = (): iRouteDataContext => {
  return useContext(RouteDataContext) as iRouteDataContext;
};

export default RouteDataProvider;

export const dictionary = {
  QUOTES: {
    MOUNTED: 'QUOTES.MOUNTED',
    WEBVIEW_ID: 'QUOTES.WEBVIEW_ID'
  }
} as const;
